@let arrowPosition = data.arrowPosition();
@let showArrow = data.showArrow();
<div
  class="flex flex-col relative drop-shadow-foreground-primary-100-shadow-30 dark:drop-shadow-foreground-secondary-100-shadow-30"
  [ngClass]="[
    arrowPosition?.position === 'top' ? 'pt-[8px]' : '',
    arrowPosition?.position === 'bottom' ? 'pb-[8px]' : '',
    arrowPosition?.position === 'left' ? 'pl-[8px]' : '',
    arrowPosition?.position === 'right' ? 'pr-[8px]' : '',
    data.popoverContainerClass() ? data.popoverContainerClass() : '',
  ]"
>
  @if (showArrow && arrowPosition) {
    <!-- Bottom arrow -->
    @if (arrowPosition.position === 'bottom') {
      <div
        class="bottom-path absolute bottom-[2px] h-[7px] w-[20px] bg-background-fixed pointer-events-none"
        [ngStyle]="{
          left: arrowPosition.left || null,
          right: arrowPosition.right || null,
          transform: 'translateX(' + arrowPosition.translateX + ')',
        }"
      ></div>
    }

    <!-- Top arrow -->
    @if (arrowPosition.position === 'top') {
      <div
        class="top-path absolute top-[2px] h-[7px] w-[20px] bg-background-fixed pointer-events-none"
        [ngStyle]="{
          left: arrowPosition.left || null,
          right: arrowPosition.right || null,
          transform: 'translateX(' + arrowPosition.translateX + ')',
        }"
      ></div>
    }

    <!-- Left arrow -->
    @if (arrowPosition.position === 'left') {
      <div
        class="left-path absolute left-[2px] h-[20px] w-[7px] bg-background-fixed pointer-events-none"
        [ngStyle]="{
          top: arrowPosition.top || null,
          bottom: arrowPosition.bottom || null,
          transform: 'translateY(' + arrowPosition.translateY + ')',
        }"
      ></div>
    }

    <!-- Right arrow -->
    @if (arrowPosition.position === 'right') {
      <div
        class="right-path absolute right-[2px] h-[20px] w-[7px] bg-background-fixed pointer-events-none"
        [ngStyle]="{
          top: arrowPosition.top || null,
          bottom: arrowPosition.bottom || null,
          transform: 'translateY(' + arrowPosition.translateY + ')',
        }"
      ></div>
    }
  }

  <!-- Content -->
  <div class="flex flex-col min-w-[68px] text-sm rounded-xl bg-background-fixed relative" [ngClass]="data.popoverClass()">
    @if (isTemplate(data.popover)) {
      <ng-container
        *ngTemplateOutlet="
          data.popover;
          context: {
            $implicit: data,
          }
        "
      ></ng-container>
    } @else if (isComponent(data.popover)) {
      <ng-container *ngComponentOutlet="data.popover"></ng-container>
    } @else {
      <div class="p-4 w-max min-w-0 max-w-full" [innerHTML]="data.popover"></div>
    }
  </div>
</div>
